<template>
    <div class=""
        :class="{[gameName]: true}" 
    >
        <p v-if="gameName=== 'crash'" class="warning">
            {{ $t('crash.ruleAlert') }}
        </p>
        <ul class="game-info__list" >
            <li v-for="(sCur, idx) of aRules"
                :key="idx" 
                :class="{dot: sCur.startsWith('●')}"
            >
                {{sCur}}
            </li>
        </ul>
    </div>
</template>


<script lang="ts" setup>
import { useI18n } from "vue-i18n";

const {t: $tFn} = useI18n();

const props = defineProps({
    gameName: String,
});
// ↓ 页签大集合，
const oLib = {
    dice: 'GameDice.ruleText', 
    crash: 'crash.ruleText', 
    blackjack: 'GameBlackJack.ruleText', 
    corgipharaoh: 'pharaoh.ruleText', 
};

const aRules = computed(()=>{
    const sKey = oLib[props.gameName];
    if (!sKey) return []; // 防止报错 
    const sText = $tFn(sKey);
    const aText = sText.split('\n');
    // console.log("sText\n", sText);
    // console.log("", );
    return aText;
});

</script>


<style scoped lang="scss">
.game-info__list{
    // all: unset;
    display: block;
    margin-bottom: 1em;
    li{
        color: var(--color_grey-20);
        font-size: 14px;
        font-weight: 500;
        line-height: 145%;
        // margin-bottom: 8px;
    }
}

// crash 游戏专用
.crash{
    .warning{
        align-items: center;
        background-color: var(--color_grey-100);
        border-radius: 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
        padding: 12px 16px;
    }
    .game-info__list{
        padding: 0 3px;
    }
    li{
        margin-top: 6px
    }
}

.blackjack{
    ul li{
        margin: 0 0 2px;
    }
}

.corgipharaoh{
    padding: 20px 0;
    .game-info__list{
        all: unset;
    }
    li{
        margin: 0;
        padding: 0 3px;
        list-style: none;
        line-height: 1.6;
    }
}

.dice{
    .game-info__list li{
        line-height: 2.6;
    }
}

</style>



